import { useEffect, useState } from "react";
import { Clock, MapPin, Users } from "lucide-react";
import api from "@/lib/api";
import { PageHero } from "@/components/public/Shared";
import { formatDate } from "@/lib/helpers";

export default function Agenda() {
  const [agendas, setAgendas] = useState([]);
  useEffect(() => { api.get("/agendas").then((r) => setAgendas(r.data)); }, []);

  return (
    <div>
      <PageHero eyebrow="Jadwal Kegiatan" title="Agenda Bawaslu"
        description="Jadwal kegiatan, rapat, sosialisasi, dan agenda resmi Bawaslu Provinsi Sulawesi Tenggara." />
      <div className="container-page py-10">
        <div className="space-y-4" data-testid="agenda-list">
          {agendas.map((a) => (
            <div key={a.id} className="bg-white border border-slate-200 rounded-xl p-5 sm:p-6 flex flex-col sm:flex-row gap-5 hover:shadow-lg transition-shadow">
              <div className="shrink-0 h-20 w-20 rounded-xl bg-navy text-white flex flex-col items-center justify-center">
                <span className="text-2xl font-extrabold leading-none">{new Date(a.date).getDate()}</span>
                <span className="text-[11px] uppercase mt-1">{new Date(a.date).toLocaleDateString("id-ID", { month: "short", year: "numeric" })}</span>
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-navy text-lg">{a.title}</h3>
                <p className="text-sm text-slate-500 mt-1">{a.description}</p>
                <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-slate-500 mt-3">
                  <span className="flex items-center gap-1.5"><Clock className="h-4 w-4 text-brandred" /> {a.time}</span>
                  <span className="flex items-center gap-1.5"><MapPin className="h-4 w-4 text-brandred" /> {a.location}</span>
                  <span className="flex items-center gap-1.5"><Users className="h-4 w-4 text-brandred" /> {a.organizer}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
